import {
  AggregateMetricsAcrossYearsUseCase,
  CalculateCumulativeStudentsUseCase,
  CalculateRiskByDayUseCase,
  CalculateRiskBySedeUseCase,
  CalculateRiskIndicatorsUseCase,
  FilterHomeDataByCurrentYearUseCase,
  GetMetricsForTheHomeUseCase,
} from '@/application/home';
import { ProcessHomeDataUseCase } from '@/application/home/processHomeDataUseCase';
import { homeApiRepository } from '@/infra';

let _getMetricsForTheHomeUseCase: GetMetricsForTheHomeUseCase | null = null;
let _processHomeDataUseCase: ProcessHomeDataUseCase | null = null;
let _calculateRiskByDayUseCase: CalculateRiskByDayUseCase | null = null;
let _calculateRiskBySedeUseCase: CalculateRiskBySedeUseCase | null = null;
let _calculateRiskIndicatorsUseCase: CalculateRiskIndicatorsUseCase | null =
  null;
let _calculateCumulativeStudentsUseCase: CalculateCumulativeStudentsUseCase | null =
  null;
let _filterHomeDataByCurrentYearUseCase: FilterHomeDataByCurrentYearUseCase | null =
  null;
let _aggregateMetricsAcrossYearsUseCase: AggregateMetricsAcrossYearsUseCase | null =
  null;

/**
 * Función que inyecta una instancia del getMetricsForTheHomeUseCase
 */
export const getMetricsForTheHomeUseCase = (): GetMetricsForTheHomeUseCase => {
  if (!_getMetricsForTheHomeUseCase)
    _getMetricsForTheHomeUseCase = new GetMetricsForTheHomeUseCase(
      homeApiRepository,
    );

  return _getMetricsForTheHomeUseCase;
};

/**
 * Función que inyecta una instancia del calculateCumulativeStudentsUseCase
 */
export const calculateCumulativeStudentsUseCase =
  (): CalculateCumulativeStudentsUseCase => {
    if (!_calculateCumulativeStudentsUseCase)
      _calculateCumulativeStudentsUseCase =
        new CalculateCumulativeStudentsUseCase();

    return _calculateCumulativeStudentsUseCase;
  };

/**
 * Función que inyecta una instancia del processHomeDataUseCase
 */
export const processHomeDataUseCase = (): ProcessHomeDataUseCase => {
  if (!_processHomeDataUseCase)
    _processHomeDataUseCase = new ProcessHomeDataUseCase(
      calculateCumulativeStudentsUseCase(),
    );

  return _processHomeDataUseCase;
};

/**
 * Función que inyecta una instancia del calculateRiskByDayUseCase
 */
export const calculateRiskByDayUseCase = (): CalculateRiskByDayUseCase => {
  if (!_calculateRiskByDayUseCase)
    _calculateRiskByDayUseCase = new CalculateRiskByDayUseCase();

  return _calculateRiskByDayUseCase;
};

/**
 * Función que inyecta una instancia del calculateRiskBySedeUseCase
 */
export const calculateRiskBySedeUseCase = (): CalculateRiskBySedeUseCase => {
  if (!_calculateRiskBySedeUseCase)
    _calculateRiskBySedeUseCase = new CalculateRiskBySedeUseCase();

  return _calculateRiskBySedeUseCase;
};

/**
 * Función que inyecta una instancia del calculateRiskIndicatorsUseCase
 */
export const calculateRiskIndicatorsUseCase =
  (): CalculateRiskIndicatorsUseCase => {
    if (!_calculateRiskIndicatorsUseCase)
      _calculateRiskIndicatorsUseCase = new CalculateRiskIndicatorsUseCase();

    return _calculateRiskIndicatorsUseCase;
  };

/**
 * Función que inyecta una instancia del filterHomeDataByCurrentYearUseCase
 */
export const filterHomeDataByCurrentYearUseCase =
  (): FilterHomeDataByCurrentYearUseCase => {
    if (!_filterHomeDataByCurrentYearUseCase)
      _filterHomeDataByCurrentYearUseCase =
        new FilterHomeDataByCurrentYearUseCase();

    return _filterHomeDataByCurrentYearUseCase;
  };

/**
 * Función que inyecta una instancia del aggregateMetricsAcrossYearsUseCase
 */
export const aggregateMetricsAcrossYearsUseCase =
  (): AggregateMetricsAcrossYearsUseCase => {
    if (!_aggregateMetricsAcrossYearsUseCase)
      _aggregateMetricsAcrossYearsUseCase =
        new AggregateMetricsAcrossYearsUseCase();

    return _aggregateMetricsAcrossYearsUseCase;
  };

/**
 * función para resetear las instancias
 */
export const resetHomeContainer = (): void => {
  _getMetricsForTheHomeUseCase = null;
  _processHomeDataUseCase = null;
  _calculateRiskByDayUseCase = null;
  _calculateRiskBySedeUseCase = null;
  _calculateRiskIndicatorsUseCase = null;
  _calculateCumulativeStudentsUseCase = null;
  _filterHomeDataByCurrentYearUseCase = null;
  _aggregateMetricsAcrossYearsUseCase = null;
};
